module.exports = __webpack_public_path__ + "media/images/athletes/1088-38645e06ce862268fb503b6a52347992.png";